import * as React from "react"

const IconCheck = (props) => (
  <svg
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.875 9.75a.75.75 0 0 1-.473-.168L1.801 7.474a.75.75 0 0 1 .945-1.166l2.02 1.637L9.17 2.527a.75.75 0 1 1 1.16.946l-4.874 6a.748.748 0 0 1-.582.277Z"
      fill="#4F4FFF"
    />
  </svg>
)

export default IconCheck
